import { useFeatureFlagContext } from 'contexts/FeatureFlagContextProvider'

import useOpeCollateralLimits from './useOpeCollateralLimits'

interface OpeMultiUnitState {
    isMultiUnitEnabled: boolean
    isLoading: boolean
    isError: boolean
}

export default function useOpeMultiUnitEnabled(
    enabled = true,
): OpeMultiUnitState {
    const featureFlags = useFeatureFlagContext()

    const isMultiUnitUiEnabled =
        featureFlags?.enableOpeMultiCollateralUi ?? false

    const { maxItems, isLoading, isError } = useOpeCollateralLimits(enabled)

    return {
        isMultiUnitEnabled:
            enabled &&
            isMultiUnitUiEnabled &&
            !isLoading &&
            !isError &&
            maxItems > 1,
        isLoading,
        isError,
    }
}
